import { ExclusionListDetailsPanelWebComponent } from './component/ExclusionListDetailsPanelWebComponent';
import { WEB_COMPONENT_EXCLUSION_LIST_DETAILS_PANEL } from '../../webcomponents.constants';
/**
 * The side-panel component for displaying list details
 * @link https://bitdefender.atlassian.net/wiki/spaces/GZDOCS/pages/1153468618/Global+Exclusions+Page
 */
export { ExclusionListDetailsPanelWebComponent };

window.customElements.define(WEB_COMPONENT_EXCLUSION_LIST_DETAILS_PANEL, ExclusionListDetailsPanelWebComponent);
